import booleanPointInPolygon from '@turf/boolean-point-in-polygon';
import center from '@turf/center';
import centerOfMass from '@turf/center-of-mass';
import {
  Position,
  multiPolygon,
  polygon as createPolygon,
} from '@turf/helpers';
import pointOnFeature from '@turf/point-on-feature';
import { first, last } from 'lodash';

class Map {
  private getValidRings(coordinates: Position[][]) {
    return coordinates
      .map((ring) => this.closePolygon(ring))
      .filter((ring) => ring.length > 3);
  }

  getPolygonCenter(coordinates?: Position[][], label?: string) {
    if (!coordinates) return;

    const validRings = this.getValidRings(coordinates);
    if (!validRings.length) {
      console.warn(
        'Geometria de talhão inválida, ignorando ao calcular centro.',
        {
          label,
          coordinates,
        },
      );
      return;
    }

    const polygon = createPolygon(validRings);
    let point = centerOfMass(polygon);
    const pointInPolygon = booleanPointInPolygon(point, polygon);

    if (!pointInPolygon) {
      point = pointOnFeature(polygon);
    }

    return {
      lat: point.geometry.coordinates[1],
      lng: point.geometry.coordinates[0],
    };
  }

  getPolygonsCenter(coordinates: Position[][][]) {
    const validPolygons = coordinates
      .map((rings) => this.getValidRings(rings))
      .filter((rings) => rings.length > 0);
    if (!validPolygons.length) {
      console.warn(
        'Nenhum talhão com geometria válida, ignorando ao calcular centro do conjunto.',
        { coordinates },
      );
      return;
    }

    const polygons = multiPolygon(validPolygons);
    const { geometry } = center(polygons);

    return {
      lat: geometry.coordinates[1],
      lng: geometry.coordinates[0],
    };
  }

  closePolygon(position: Position[]) {
    const firstPosition = first(position);

    if (!firstPosition) return position;

    const lastPosition = last(position)!;

    const same = this.isSamePosition(firstPosition, lastPosition);

    return same ? position : [...position, firstPosition];
  }

  private isSamePosition(positionA: Position, positionB: Position) {
    return positionA[0] === positionB[0] && positionA[1] === positionB[1];
  }
}

export default new Map();
